import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Modal from '../../../components/modal/index';
import { Warning } from '../../../helpers/icon-dictionary';
import SvgIcon from '../../svg-icon/svg-icon';
import Button from '../../button/index';
import css from '../index.scss';
import { DARK } from '../../button/variants';
import messages from '../messages';

const RollOverConfirmation = (props) => {
    const { showRollOverConfirmation,
        intl,
        closeRollOverConfirmation,
        rolloverType,
        onRollOverConfirmationRequest,
        selectedProduct,
        rolloverItems,
        isPerformingRollOver } = props;

    const rolloverMessage = rolloverType === 'FullRollover' ?
        intl.formatMessage(messages.fullRollOver) :
        intl.formatMessage(messages.partialRollOver);
    return (<Modal show={showRollOverConfirmation}>
        <div className={css.confirmationContainer}>
            <div className={css.icon}>
                <SvgIcon icon={Warning} />
            </div>
            <div className={css.confirmTitle}>{intl.formatMessage(messages.aboutToProceed)} {rolloverMessage}</div>
            <div className={css.confirmTitle}>{intl.formatMessage(messages.areYouSure)}</div>
            <div className={css.confirmBtnContainer}>
                <Button
                    disabled={isPerformingRollOver}
                    handleOnClick={closeRollOverConfirmation}
                    label={intl.formatMessage(messages.cancel)}
                    variant={DARK} />
                <Button
                    disabled={isPerformingRollOver}
                    handleOnClick={() => onRollOverConfirmationRequest(rolloverType, selectedProduct.id, rolloverItems)}
                    label={intl.formatMessage(messages.proceed)}
                    variant={DARK} />
            </div>
        </div>
    </Modal>);
};

RollOverConfirmation.propTypes = {
    showRollOverConfirmation: PropTypes.bool,
    intl: intlShape.isRequired,
    closeRollOverConfirmation: PropTypes.func,
    rolloverType: PropTypes.string,
    onRollOverConfirmationRequest: PropTypes.func,
    selectedProduct: PropTypes.object,
    rolloverItems: PropTypes.array,
    isPerformingRollOver: PropTypes.bool
};

export default injectIntl(styleable(css)(RollOverConfirmation));



// WEBPACK FOOTER //
// ./app/components/roll-over/modals/confirmation.js